/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, January 2020
 */
import { Nullish } from '../../../core/lib';

type ClassName = Nullish<string | number | string[] | { [key: string]: boolean }>;

/**
 * Push a value into an array if it doesn't exists.
 *
 * @param array Array to push to.
 * @param values Spread of values to push.
 */
function pushUnique<T>(array: T[], ...values: T[]): void {
    values.forEach(value => {
        if (!array.includes(value)) {
            array.push(value);
        }
    });
}

/**
 * A utility to create HTML class names.
 * This is a port of https://www.npmjs.com/package/classnames
 *
 * @param args Class-like list of values.
 * @returns A string of HTML class names.
 */
export default function classnames(...args: ClassName[]): string {
    const cls: Array<string | number> = [];

    args.forEach(arg => {
        if (Array.isArray(arg)) {
            pushUnique(cls, ...arg);
        } else if (arg != null) {
            if (typeof arg === 'object') {
                Object.keys(arg).forEach(key => {
                    if (arg[key]) {
                        pushUnique(cls, key);
                    }
                });
            } else {
                pushUnique(cls, arg);
            }
        }
    });

    return cls.join(' ');
}



// WEBPACK FOOTER //
// ./src/packages/components/lib/utils/classnames.ts